import React from "react";

import {
  Box,
  Grid,
  Slider,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  colors,
  makeStyles,
} from "@material-ui/core";

import { FranchiseType } from "@hubcapp/types";
import { TableCard } from "@hubcapp/components/Cards";

import { LearnerCapacity, Skeleton } from "./components";
import { LessonPreferencesProps } from "./types";

const useStyles = makeStyles(theme => ({
  cell: { padding: theme.spacing(3) },
  sliderWrapper: {
    padding: theme.spacing(2, 2, 0),
  },
  flexGrow: {
    flexGrow: 1,
  },
  input: {
    maxWidth: "200px",
  },
  inputLabel: {
    color: colors.blueGrey[900],
  },
  capacityRoot: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    maxHeight: "96px",
  },
  learnerCapacityTitle: {
    fontSize: "12px",
    color: colors.blueGrey[600],
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(-1),
  },
  progress: {
    margin: theme.spacing(0, 4),
    flexGrow: 1,
  },
  progressBar: {
    backgroundColor: "#0D73D9",
  },
}));

const LessonPreferences: React.FC<LessonPreferencesProps> = ({
  disabled = false,
  loading = false,
  learnerCapacity,
  franchiseType = FranchiseType.Full,
  travelTime,
  onTravelTimeChange = () => {},
  onLearnerCapacityChange = () => {},
  onTravelTimeClick = () => {},
  capLock,
  currentTravelTime,
}) => {
  const classes = useStyles();
  const title = "Lesson preferences";
  const travelTimeText =
    currentTravelTime === 0 ? "Not set" : `${currentTravelTime}m`;
  return loading ? (
    <Skeleton title={title} />
  ) : (
    <TableCard title={title} data-test="lesson-preferences">
      <TableBody>
        <TableRow>
          <TableCell classes={{ root: classes.cell }}>
            <Box maxWidth={400}>
              <Grid container>
                <Grid item xs>
                  <Typography id="travel-time-slider" gutterBottom>
                    Travel time to lesson (mins)
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography
                    id="travel-time-slider"
                    data-test="travel-time-text"
                    gutterBottom
                  >
                    {travelTimeText}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
            <Box className={classes.sliderWrapper} maxWidth={400}>
              <Slider
                disabled={disabled}
                value={travelTime}
                aria-labelledby="travel-time-slider"
                valueLabelDisplay="auto"
                onChange={onTravelTimeChange}
                onClick={onTravelTimeClick}
                data-test="travel-time-slider"
                step={15}
                marks={[
                  {
                    value: 15,
                    label: "15m",
                  },
                  {
                    value: 30,
                    label: "30m",
                  },
                  {
                    value: 45,
                    label: "45m",
                  },
                  {
                    value: 60,
                    label: "60m",
                  },
                ]}
                min={15}
                max={60}
              />
            </Box>
          </TableCell>
        </TableRow>
        {learnerCapacity && franchiseType !== FranchiseType.Motability && (
          <LearnerCapacity
            capLock={capLock}
            franchiseType={franchiseType}
            onLearnerCapacityChange={onLearnerCapacityChange}
            {...learnerCapacity}
          />
        )}
      </TableBody>
    </TableCard>
  );
};

export default LessonPreferences;
